<template>
  <form-field
    :name="field.name"
    :hide="field.hide"
  >
    <v-text-field
      v-model="fileName"
      v-bind="field.props"
      @click="onPickFile"
      prepend-icon="attach_file"
      box
    />
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      :accept="field.props.accept || 'image/*'"
      @change="onFilePicked"
    >
    <v-img
      :src="url"
      contain
      max-height="300"
    />
    <!-- <v-btn
      color="primary"
      @click.stop="onUploadSelectedFileClick"
      :loading="loading"
    >
      UPLOAD
    </v-btn> -->
  </form-field>
</template>

<script>
import formField from '@/mixins/form-field'

export default {
  mixins: [formField],
  data () {
    return {
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      size: '',
      type: '',
      lastModifiedDate: '',
      loading: false,
    }
  },
  methods: {
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        const file = files[0]
        this.fileName = file.name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        if (this.field.props.maxSize && file.size > this.field.props.maxSize) {
          this.field.error = `File size must be less than ${(this.field.props.maxSize / 1024 / 1024).toFixed(1)} MB`
          this.fileName = ''
          return
        }
        this.field.error = null
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.field.value = this.url
          this.fileObject = file // this is an file that can be sent to server...
          this.field.file = file
        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },
    // onUploadSelectedFileClick () {
    //   this.loading = true

    //   console.log(this.url)
    //   // A file is not chosen!
    //   if (!this.fileObject) {
    //     alert('No file!!')
    //   }
    //   // DO YOUR JOB HERE with fileObjectToUpload
    //   // https://developer.mozilla.org/en-US/docs/Web/API/File/File
    //   this.name = this.fileObject.name
    //   this.size = this.fileObject.size
    //   this.type = this.fileObject.type
    //   this.lastModifiedDate = this.fileObject.lastModifiedDate
    //   // DO YOUR JOB HERE with fileObjectToUpload
    //   this.loading = false
    // },
  },
}

</script>
